import React from "react";
import style from "./workingFile.module.scss";
import image from "../../SlaFile/sla1images/taizoin.svg";
import companyLogo from "../../assets/images/TaizoNewLogo.png";

function Header() {
  return (
    <div>
      <div className={`${style.header}`}>
        <div className="d-flex justify-content-between align-items-end">
          <div>
            <img
              className={style["logo-mark-icon1"]}
              alt=""
              src={companyLogo}
            />{" "}
            {/* <img className={style["taizoin-icon1"]} alt="logo" src={image} /> */}
            {/* <img src={image} alt="image" className={`${style.headerImage}`} /> */}
          </div>
          <div className={`${style.InvoiceLabel}`}>
            <div className={style.parentDiv}>
              <div className={style.childDiv}>
                <span className="me-3">INVOICE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
